export default "__VITE_ASSET__DoyFWupS__"